const defaultSteps = [
  {
    name: 'Participant Information',
  },
  {
    name: 'Review & Pay',
  },
  {
    name: 'Waiver',
  },
]

const composeSteps = ({ paymentRequired, shouldShowWaiver }) => {
  let steps = defaultSteps
  if (!paymentRequired) {
    steps = steps.filter(step => step.name !== 'Review & Pay')
  }
  if (!shouldShowWaiver) {
    steps = steps.filter(step => step.name !== 'Waiver')
  }
  return steps
}

const formatRegistrationPhoneNumber = phoneNumber => {
  const formatted = phoneNumber?.replace(/\D/g, '')
  return formatted?.length > 0 ? formatted : null
}

const buildPrepareRegisterPayload = ({
  participants = [],
  contact = {},
  useFirstParticipantContactInformation,
} = {}) => {
  const participantAttributes = participants.map(p => ({
    firstName: p.firstName,
    lastName: p.lastName,
    email: (p.email || '').length > 0 ? p.email : null,
    phoneNumber: formatRegistrationPhoneNumber(p.phoneNumber || ''),
    isMinor: p.type === 'Junior',
  }))

  const firstParticipant = participants[0] || {}
  const contactAttributes = useFirstParticipantContactInformation
    ? {
      firstName: firstParticipant.firstName,
      lastName: firstParticipant.lastName,
      email: firstParticipant.email,
      phone: formatRegistrationPhoneNumber(firstParticipant.phoneNumber || ''),
    }
    : {
      firstName: contact.firstName,
      lastName: contact.lastName,
      email: contact.email,
      phone: formatRegistrationPhoneNumber(contact.phoneNumber || ''),
    }

  return {
    participants: participantAttributes,
    contact: contactAttributes,
  }
}

export {
  composeSteps,
  formatRegistrationPhoneNumber,
  buildPrepareRegisterPayload,
}
